import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { userDetailEditQuery } from './constant';
import { Loading } from 'sha-el-design/lib';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { UserDetailNode } from '../../../schema';
import { AddUserDetail } from './AddUserDetail';
import { toGlobalId } from '../../helpers';
import { match } from 'react-router';

export class EditUserDetail extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <GraphqlQuery
        variables={{ id: this.props.match.params.id }}
        queryString={userDetailEditQuery}
        render={(response: { userDetail: UserDetailNode }, error, loading) => {
          if (error) {
            return <div>Something went wrong</div>;
          }
          return (
            <Loading
              isLoading={loading}
              render={() => (
                // AddUserDetail renders the whole page chrome itself (title,
                // breadcrumbs, back arrow) and switches to edit copy when the
                // record has an id -- the old Card-with-a-Back-button wrapper
                // here just double-framed it.
                <AddUserDetail
                  userDetail={{
                    id: response.userDetail.id,
                    states: response.userDetail.states.map((v) => toGlobalId(`StateNode:${v}`)) as any[],
                    towns: response.userDetail.towns.map((v) => toGlobalId(`TownNode:${v}`)) as any[],
                    areas: response.userDetail.areas.map((v) => toGlobalId(`AreaNode:${v}`)) as any[],
                    username: nestedAccess(response.userDetail.user, 'username'),
                    password: nestedAccess(response.userDetail.user, 'password'),
                    employee: nestedAccess(response.userDetail.employee, 'id'),
                    supervisor: nestedAccess(response.userDetail.supervisor, 'id'),
                    userType: response.userDetail.userType,
                  }}
                  stateList={response.userDetail.stateList}
                  townList={response.userDetail.townList}
                  selectedEmployee={{
                    node: response.userDetail.employee,
                    cursor: '',
                  }}
                  selectedSupervisor={{
                    node: response.userDetail.supervisor,
                    cursor: '',
                  }}
                  selectedStates={response.userDetail.stateList.map((state) => ({
                    node: state,
                    cursor: '',
                  }))}
                  selectedTowns={response.userDetail.townList.map((town) => ({
                    node: town,
                    cursor: '',
                  }))}
                  selectedAreas={response.userDetail.areaList.map((area) => ({
                    node: area,
                    cursor: '',
                  }))}
                />
              )}
            />
          );
        }}
      />
    );
  }
}

interface Props {
  match: match<{ id: string }>;
}
